// Turbo
import "@hotwired/turbo-rails"
import 'animate.css'
//Turbo.start()

// Aos
import AOS from "aos";
import 'aos/dist/aos.css';
AOS.init({
  once: true,
  duration: 2000,
  anchorPlacement: 'top-bottom',
});

// Flowbite
import "flowbite/dist/flowbite.turbo.js"
import "flowbite/dist/datepicker.turbo.js"
import "flatpickr/dist/flatpickr.css"

import './controllers/flowbite_overrides'

//import ActiveStorage from '@rails/activestorage'
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
//

// Stimulus controllers
import '../javascript/controllers'

// Action cable channels
import './channels/consumer'
import './channels/mailer_opener_channel'
